/* DRE
 * Duas colunas: por projeto e no mês. O mês é o ano dividido por 12, e cada
 * linha unitária é multiplicada pelos projetos do mês que o motor calculou:
 * nenhuma soma nova, só a mesma conta em outra unidade. */

import { Celula } from '@/componentes/celula';
import { Dre, LinhaDre } from '@/componentes/linha-dre';
import { lancamentosDoProjeto } from '@/componentes/memoria-de-calculo';
import { Valor } from '@/componentes/valor';
import type { Cenario, Parametros } from '@/dados';

import { Cabecalho } from './cabecalho';
import { quantia } from './grandezas';

export function DreDoProjeto({
  p,
  atual,
  semPreco,
}: {
  p: Parametros;
  /** `null` quando o motor recusa opinar: não há preço deste projeto a decompor. */
  atual: Cenario | null;
  semPreco: boolean;
}) {
  const linhas = lancamentosDoProjeto(p, atual, semPreco);

  return (
    <Celula como="section" assenta atraso={380}>
      <Cabecalho titulo="DRE do projeto" nota="A mesma conta, na linguagem do contador." />

      {/* Cabeçalho das duas colunas, alinhado à grade das linhas. */}
      <div className="mb-2 hidden grid-cols-[16px_1fr_auto_auto] gap-x-3 px-3 text-apoio font-semibold text-tinta-2 mesa:grid">
        <span />
        <span />
        <span className="min-w-coluna-valor text-right">Por projeto</span>
        <span className="min-w-coluna-pct text-right">Mês (média)</span>
      </div>

      <Dre>
        {linhas.map((l) => (
          <LinhaDre
            key={l.nome}
            nome={l.nome}
            {...(l.nota === undefined ? {} : { nota: l.nota })}
            operador={l.operador ?? 'menos'}
            campo={l.campo ?? 'nenhum'}
            total={l.total ?? false}
            tom={l.perda ? 'negativo' : 'neutro'}
            valor={<Valor valor={l.projeto} formato="moeda" tamanho="apoio" />}
            percentual={<Valor valor={l.mes} formato="moeda" tamanho="nota" tom="apagado" />}
          />
        ))}
      </Dre>

      <p className="apoio-nota mt-4">
        A coluna do mês é a do projeto multiplicada por {quantia(atual?.qtdMes)} projetos, o volume
        médio do mês. A despesa fixa aparece rateada por projeto e cheia no mês: é o mesmo dinheiro
        visto de dois lugares.
      </p>
    </Celula>
  );
}
